export enum FONT_SIZE {
  SMALL = '0.625rem',
  NORMAL = '0.8125rem',
  MEDIUM = '1rem',
  LARGE = '1.375rem',
  XLARGE = '1.5rem',
  XXLARGE = '2rem'
}
